export const themeEmojis = {
  beginnings: "🌱",
  freedom: "🕊️",
  potential: "✨",
  power: "🔥",
  manifestation: "🪄",
  action: "🏃‍♂️",
  intuition: "🌙",
  mystery: "🌀",
  knowledge: "📚",
  nurturing: "🤱",
  abundance: "💰",
  growth: "🌿",
  structure: "🏛️",
  authority: "👑",
  control: "🕹️",
  tradition: "📜",
  guidance: "🧭",
  spirituality: "🧘",
  love: "❤️",
  relationships: "💞",
  choice: "🪢",
  determination: "🎯",
  victory: "🏆",
  strength: "💪",
  courage: "🦁",
  patience: "⏳",
  solitude: "🧙",
  wisdom: "🦉",
  reflection: "🪞",
  change: "🔄",
  fate: "🎰",
  cycles: "🔁",
  truth: "🧾",
  balance: "⚖️",
  sacrifice: "🙏",
  release: "💨",
  endings: "🔚",
  transformation: "🧬",
  rebirth: "🌅",
  moderation: "🥣",
  healing: "💖",
  temptation: "🍎",
  materialism: "💸",
  addiction: "🧪",
  upheaval: "🌪️",
  shock: "⚡",
  hope: "⭐",
  renewal: "♻️",
  illusion: "🫥",
  fear: "😨",
  joy: "🎉",
  success: "💫",
  clarity: "🔍",
  awakening: "🌞",
  completion: "🔒",
  wholeness: "🧩",
  celebration: "🥂",
  connection: "🤝",
  rest: "🛏️",
  struggle: "🥀",
  scarcity: "📉",
  deception: "🕵️",
  introspection: "🧠",
  independence: "🏕️",
  pain: "💔",
  curiosity: "🧃",
  adventure: "🧗",
  energy: "⚡",
  romance: "💘",
  creativity: "🎨",
  idealism: "🌈",
  stability: "🧱",
  logic: "🧠",
}; 